import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import ReactLoader from 'components/Loader';
import { Container } from 'reactstrap';

import PriceCatalogService from '../../../service/priceCatalogService';
import { icon_column_style } from 'assets/styles/table_custom_style';
import { individual_icon_header_style } from 'assets/styles/table_custom_style';
import { individual_column_style } from 'assets/styles/table_custom_style';
import { individual_header_style } from 'assets/styles/table_custom_style';

const ProductsByPriceCatalogTable = ({
  catalogId,
  loadingTable,
  onTableLoaded
}) => {
  const [products, setProducts] = useState([]);

  const columns = [
    {
      dataField: 'name',
      text: 'Nome',
      style: individual_column_style,
      headerStyle: individual_header_style,
      sort: true
    },
    {
      dataField: 'code',
      text: 'CÓDIGO',
      style: individual_column_style,
      headerStyle: individual_header_style,
      sort: true
    },
    {
      dataField: 'basePrice',
      text: 'VALOR PADRÃO',
      style: individual_column_style,
      headerStyle: individual_header_style,
      sort: true
    },
    {
      dataField: 'catalogPrice',
      text: 'VALOR NO CATÁLOGO',
      style: individual_column_style,
      headerStyle: individual_header_style,
      sort: true
    },
    {
      dataField: 'habilitar/desabilitar',
      text: 'HABILITADO/DESABILITADO',
      style: icon_column_style,
      headerStyle: individual_icon_header_style,
      formatter: (_, row) => (row.isActive ? 'HABILITADO' : 'DESABILITADO')
    }
  ];

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await PriceCatalogService.getProductsByPriceCatalogId(
          catalogId
        );
        const sortedProducts = response.data.data.sort((a, b) => {
          if (a.isActive === b.isActive) return 0;
          return a.isActive ? -1 : 1;
        });
        setProducts(sortedProducts);
        onTableLoaded(false);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    if (catalogId) {
      fetchProducts();
    }
  }, [catalogId, onTableLoaded]);

  return (
    <>
      {loadingTable ? (
        <Container
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: '200px' }}
        >
          <ReactLoader />
        </Container>
      ) : (
        <ToolkitProvider keyField="id" data={products} columns={columns}>
          {(props) => (
            <div style={{ width: '100%', overflowX: 'auto' }}>
              <BootstrapTable
                {...props.baseProps}
                bootstrap4={true}
                bordered={false}
                wrapperClasses="table-responsive"
                classes="align-items-center table"
                style={{ width: '100%' }}
                noDataIndication="Nenhum produto encontrado"
              />
            </div>
          )}
        </ToolkitProvider>
      )}
    </>
  );
};

export default ProductsByPriceCatalogTable;
